<template>
  <div>
    <v-card tile flat class="my-5">
      <v-card-text class="pa-0">
        <v-row no-gutters>
          <v-col cols="2">
            <div class="bg-kiri"></div>
          </v-col>
          <v-col cols="10" class="pa-5">
            <div class="body-1 black--text mb-2">Daftar Pengawas Peserta Diklat IKM</div>
            <h4 class="orange--text text--darken-1">Informasi Penting!</h4>
            <ol class="black--text text-justify">
              <li>Fitur kelola Diklat IKM Pengawas hanya muncul pada peran Admin Sekolah Penggerak di BGP/BBGP saja</li>
              <li>
                Dalam pemilihan calon peserta pengawas yang akan diikutkan dalam Diklat IKM Pengawas BGP/BBGP diwajibkan
                untuk koordinasi dengan Dinas Pendidikan wilayah pengawas bertugas. Atau UPT terkait lainnya
              </li>
              <li>
                Proses kelola peserta pengawas ini, bisa dilakukan pembatalan/penghapusan dari daftar kandidat peserta
                pengawas yang telah dipilih sebelumnya.
              </li>
              <li>
                Data pengawas yang muncul dalam listing pengawas yang dapat dipilih sebagai kandidat peserta pengawas
                diambil dari data yang tersedia di SIMTENDIK yang telah melakukan keaktifan semester 1 pada 2023
              </li>
              <li>
                Jika terdapat data pengawas yang tidak muncul dalam listing. Maka silakan dicroscek ketersedian datanya
                pada SIMTENDIK terlebih dahulu
              </li>
              <li>
                Kriteria pengawas yang dapat mengikut Diklat IKM Pengawas beberapa diantaranya adalah:
                <ol type="a">
                  <li> Terdata dan aktif di SIMTENDIK </li>
                  <li> Bukan pengawas membina jenjang SMK </li>
                  <li> Belum pernah mengikuti PKP Angkatan 1, 2, 3 </li>
                  <li> Pengawas bukan merupakan Fasilitator </li>
                </ol>
              </li>
            </ol>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <statistik ref="stats" :value="statistik" />
    <v-card flat>
      <v-card-title class="py-1">
        <base-table-header
          :options="{ header: 'pa-0' }"
          outlined-button
          btn-filter
          btn-download
          @search="onSearch"
          @reload="onReload"
          @filter="onFilter"
          @download="onDownloadList"
        >
          <template v-slot:subtitle>
            <div class="subtitle-1 font-weight-medium black--text">
              Daftar Pengawas Peserta Diklat
            </div>
          </template>
          <template v-slot:toolbarAfter>
            <v-btn
              v-if="$allow('psp-peserta-diklat-ikm-pengawas.save')"
              color="info"
              depressed
              class="ml-2"
              @click="onAddPeserta"
            >
              <v-icon left>mdi-plus</v-icon> Tambah
            </v-btn>
          </template>
        </base-table-header>
      </v-card-title>
      <v-divider />
      <base-list-filter
        ref="filter"
        title="Pilih Filter Status"
        :filtered="filtered"
        :filters="formFilter"
        :paramsFilter="filters"
        @save="filterSave"
      />
      <v-card-text class="pa-0">
        <base-list-table
          :hideHeader="true"
          :loading="loading"
          :item="data"
          :total="total"
          :usePaging="false"
          @fetch="fetchData"
        >
          <template slot-scope="{ item }">
            <td>
              <v-list two-line>
                <v-list-item dense class="px-0">
                  <v-list-item-avatar class="mr-5">
                    <v-avatar color="green">
                      <v-icon dark>mdi-account</v-icon>
                    </v-avatar>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-row>
                      <v-col cols="12" lg="4">
                        <span class="grey--text" style="font-size: 13px;"> Nama Pengawas </span>
                        <div class="info--text mt-1" style="font-size: 15px">
                          {{ $getDeepObj(item, 'ptk.nama') || '-' }}
                        </div>
                        <div class="body-2">
                          <span class="font-weight-medium">SIMPKB ID: </span>
                          {{ $getDeepObj(item, 'ptk_id') || '-' }}
                        </div>
                      </v-col>
                      <v-col cols="12" lg="4">
                        <span class="grey--text" style="font-size: 13px;"> Instansi Bertugas </span>
                        <div class="font-weight-regular mt-1" style="font-size: 15px;">
                          {{ $getDeepObj(item, 'ptk.ptk_tugas.instansi.nama') }}
                        </div>
                      </v-col>
                      <v-col cols="12" lg="4" v-if="$allow('psp-peserta-diklat-ikm-pengawas.save')">
                        <span class="grey--text" style="font-size: 13px;"> Diajukan oleh </span>
                        <div class="font-weight-regular mt-1" style="font-size: 15px;">
                          <span class="font-weight-medium"> {{ $getDeepObj(item, 'akun.nama') }} </span>
                          <div class="body-2 grey--text text--darken-1">
                            {{ $localDate($getDeepObj(item, 'created_at'), false, true) }} WIB
                          </div>
                        </div>
                      </v-col>
                      <v-col cols="12" lg="4" v-else>
                        <span class="grey--text" style="font-size: 13px;"> Instansi BGP / BBGP </span>
                        <div class="font-weight-regular mt-1" style="font-size: 15px;">
                          <span class="font-weight-medium"> {{ $getDeepObj(item, 'instansi.nama') }} </span>
                        </div>
                      </v-col>
                    </v-row>
                  </v-list-item-content>
                  <v-list-item-action-text>
                    <base-list-action
                      :data="item"
                      :actions="actions"
                      :allow="allow"
                      v-if="allowAction"
                      @action="onAction"
                    />
                  </v-list-item-action-text>
                </v-list-item>
              </v-list>
            </td>
          </template>
        </base-list-table>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <base-table-footer :pageTotal="pageTotal" :allow="!allow" @changePage="onChangePage"></base-table-footer>
      </v-card-actions>
    </v-card>
    <popup-kandidat ref="kandidat" :meta="dataMeta || {}" />
    <base-modal-full ref="modal" :title="formulir.title" :use-save="!formulir.preview" @save="onSavePeserta">
      <form-peserta ref="formulir" :preview="formulir.preview" />
    </base-modal-full>
  </div>
</template>

<script>
import Statistik from './component/Statistik';
import FormPeserta from './form/Peserta';
import PopupKandidat from './popup/Kandidat';
import list from '@mixins/list';
import Actions from './actions';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'PesertaDiklatIkmPengawas',
  components: { Statistik, FormPeserta, PopupKandidat },
  mixins: [list],
  data() {
    return {
      actions: Actions,
      formulir: {},
      statistik: {},
      listLaporan: [
        {
          key: 'download',
          label: `Laporan Peserta Diklat IKM`,
        },
      ],
    };
  },
  computed: {
    ...mapState('preferensi', {
      instansi: (state) => state?.data?.instansi ?? {},
      instansiBgp: (state) => state.instansi_bgp || [],
    }),

    mInstansiBgp() {
      return this.$arrToObj(this.instansiBgp, 'instansi_id');
    },

    mOpsiBgp() {
      return this.instansiBgp.map((ins) => {
        return {
          text: ins.nama,
          value: ins.instansi_id,
        };
      });
    },

    mJenjang() {
      return {
        1: 'PAUD',
        2: 'SD',
        3: 'SMP',
        4: 'SMA',
        5: 'SMK',
        6: 'SLB',
      };
    },

    filtersMaster() {
      return {
        instansi_id_bgp: this.instansiBgp,
        k_jenjang: this.mJenjang,
      };
    },

    filtered() {
      let label = [];
      for (let key in this.filters) {
        let value = this.filters[key];
        if (key === 'instansi_id_bgp') {
          label.push((this.mInstansiBgp[value] && this.mInstansiBgp[value]['nama']) || '');
        } else if (key === 'gelombang_profil') {
          label.push(this.filtersMaster[key][value] || '');
        }
      }
      return label;
    },

    formFilter() {
      const result = [
        {
          label: 'Jenjang Binaan',
          model: 'k_jenjang',
          type: 'select',
          props: ['attach'],
          master: this.$mapForMaster(this.mJenjang),
          labelColor: 'secondary',
          placeholder: 'Pilih Jenjang',
          grid: { cols: 12, lg: 6 },
        },
      ];

      if (this.instansi.k_jenis_instansi === 7) {
        result.push({
          label: 'Pilih Instansi BGP / BBGP',
          model: 'instansi_id_bgp',
          type: 'select',
          props: ['attach'],
          master: this.mOpsiBgp,
          labelColor: 'secondary',
          grid: { cols: 12, lg: 6 },
        });
      }

      return result;
    },
  },
  async created() {
    await this.getInstansiBgp();
    await this.getStatistik();
  },
  methods: {
    ...mapActions('preferensi', ['getInstansiBgp']),
    ...mapActions('ikmPengawas', ['fetch', 'listActions', 'downloadList']),

    allowAction(exclude) {
      let allow = false;
      for (const act of this.actions) {
        if (!allow && exclude && exclude.indexOf(act.event) === -1) {
          allow = this.$allow(act.akses);
        }
      }

      return allow;
    },

    allow(action, data) {
      let allow = true;
      switch (action.event) {
        default:
          allow = this.$allow(action.akses, data.policies);
          break;
      }
      return allow;
    },

    renderSelect(item) {
      return [
        '<div class="black--text" style="font-size: 15px">Apakah Anda yakin ingin mengapus data berikut menjadi peserta diklat?</div>',
        '<div class="mt-2 pa-3 grey lighten-3 black--text">',
        '<div class="v-list-item__content pa-2 white">',
        '<div class="row">',
        '<div class="col-lg-6 col-12">',
        '<span class="grey--text" style="font-size: 13px;"> Nama Pengawas </span>',
        `<div class="info--text mt-1" style="font-size: 15px;">${this.$getDeepObj(item, 'ptk.nama') || ''}</div>`,
        `<div class="body-2"><span class="font-weight-medium">SIMPKB ID: </span> ${this.$getDeepObj(item, 'ptk_id') ||
          ''}</div></div>`,
        '<div class="col-lg-6 col-12">',
        '<span class="grey--text" style="font-size: 13px;"> Instansi Bertugas </span>',
        '<div class="font-weight-regular mt-1" style="font-size: 15px;">',
        `${this.$getDeepObj(item, 'instansi.nama') || ''}`,
        '</div>',
        '</div>',
        '</div>',
        '</div>',
        '</div>',
      ].join('');
    },

    downloadLaporan(url) {
      const params = Object.assign(this.params, this.$isObject(this.filters) ? this.filters : {});

      this.downloadList({ params, url: url.dokumen }).then((url) => {
        this.$downloadFile(url);
      });
    },

    getStatistik() {
      this.$refs.stats.fetch();
    },

    onChangeJenjang() {
      this.page = 1;
      this.onReload();
    },

    onViewPeserta(data) {
      this.$set(this.formulir, 'title', 'Detail Peserta Diklat');
      this.$set(this.formulir, 'preview', true);

      this.$refs.modal.open();
      this.$nextTick(() => {
        this.$refs.formulir.reset(data.ptk_id);
      });
    },

    onAddPeserta() {
      this.$set(this.formulir, 'title', 'Tambah Peserta Diklat');
      this.$set(this.formulir, 'preview', false);

      this.$refs.modal.open();
      this.$nextTick(() => {
        this.$refs.formulir.reset();
      });
    },

    onSavePeserta() {
      const values = this.$refs.formulir.getValue();

      if (!values.ptk) {
        this.$refs.modal.loading = false;
        this.$error('Silahkan pilih pengawas terlebih dahulu');
        return;
      }

      this.listActions({ endpoint: `${values.ptk.ptk_id}/save` })
        .then(() => {
          this.$success('Pengawas berhasil ditambahkan');
          this.$refs.modal.close();
          this.getStatistik();
          this.onReload();
        })
        .catch(() => {
          this.$refs.modal.loading = false;
        });
    },

    onDelPeserta(item) {
      this.$confirm(this.renderSelect(item), 'Konfirmasi hapus peserta', {
        tipe: 'error',
      }).then(() => {
        this.listActions({ endpoint: `${item.psp_diklat_peserta_id}/delete` }).then(() => {
          this.$success('Peserta berhasil dihapus');
          this.getStatistik();
          this.onReload();
        });
      });
    },
  },
};
</script>

<style scoped>
.bg-kiri {
  background: #bbdefb;
  height: 100%;
}
</style>
